'use strict';

var __assign =
  (void 0 && (void 0).__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

    return __assign.apply(this, arguments);
  };

var __importDefault =
  (void 0 && (void 0).__importDefault) ||
  function (mod) {
    return mod && mod.__esModule
      ? mod
      : {
          default: mod,
        };
  };

Object.defineProperty(exports, '__esModule', {
  value: true,
});

var react_1 = __importDefault(require('react'));

var Icon_1 = __importDefault(require('../Icon'));

var Palette = function Palette(props) {
  return react_1.default.createElement(
    Icon_1.default,
    __assign({}, props),
    react_1.default.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M20.5 12.3846V12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5H13.2118C14.0214 20.5 14.6406 19.7783 14.5174 18.9781L14.294 17.5258L14.2876 17.4845C14.2476 17.2245 14.2051 16.9489 14.1879 16.7099C14.1688 16.4454 14.1663 16.0814 14.3007 15.6893C14.5079 15.0848 14.9388 14.5826 15.5047 14.2859C15.8718 14.0934 16.232 14.0405 16.4963 14.0192C16.7352 13.9999 17.014 13.9999 17.277 14L17.3188 14H18.8846C19.0027 14 19.0284 13.9998 19.0453 13.9993C19.8382 13.9754 20.4754 13.3382 20.4993 12.5453C20.4998 12.5284 20.5 12.5027 20.5 12.3846ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22H13.2118C14.9407 22 16.2629 20.4589 16 18.75L15.7766 17.2977C15.6854 16.705 15.6398 16.4087 15.7197 16.1757C15.8025 15.9339 15.9749 15.733 16.2013 15.6144C16.4194 15.5 16.7192 15.5 17.3188 15.5H18.8846C18.9917 15.5 19.0453 15.5 19.0906 15.4986C20.6764 15.4507 21.9507 14.1764 21.9986 12.5906C22 12.5453 22 12.4917 22 12.3846V12C22 6.47715 17.5228 2 12 2ZM10 16C10.5523 16 11 15.5523 11 15C11 14.4477 10.5523 14 10 14C9.44772 14 9 14.4477 9 15C9 15.5523 9.44772 16 10 16ZM10 17.5C11.3807 17.5 12.5 16.3807 12.5 15C12.5 13.6193 11.3807 12.5 10 12.5C8.61929 12.5 7.5 13.6193 7.5 15C7.5 16.3807 8.61929 17.5 10 17.5ZM17 11C17.5523 11 18 10.5523 18 10C18 9.44772 17.5523 9 17 9C16.4477 9 16 9.44772 16 10C16 10.5523 16.4477 11 17 11ZM8 10C8 10.5523 7.55228 11 7 11C6.44772 11 6 10.5523 6 10C6 9.44772 6.44772 9 7 9C7.55228 9 8 9.44772 8 10ZM12 7C12.5523 7 13 6.55228 13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6C11 6.55228 11.4477 7 12 7ZM16.3752 7C16.3752 7.55228 15.9275 8 15.3752 8C14.823 8 14.3752 7.55228 14.3752 7C14.3752 6.44772 14.823 6 15.3752 6C15.9275 6 16.3752 6.44772 16.3752 7ZM8.625 8C9.17728 8 9.625 7.55228 9.625 7C9.625 6.44772 9.17728 6 8.625 6C8.07272 6 7.625 6.44772 7.625 7C7.625 7.55228 8.07272 8 8.625 8Z',
    })
  );
};

Palette.displayName = 'Palette';
exports.default = Palette;
